import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "motion/react";
import { pageVariants } from "./components/layout/Motion3D";
import { Toaster } from "./components/ui/sonner";
import { Header } from "./components/layout/Header";
import { Footer } from "./components/layout/Footer";
import { useAITextHighlight } from "./hooks/useAITextHighlight";
import Home from "./pages/Home";
import About from "./pages/About";
import Projects from "./pages/Projects";
import People from "./pages/People";
import TechStack from "./pages/TechStack";
import Investors from "./pages/Investors";
import Contact from "./pages/Contact";
import Legal from "./pages/Legal";
import Marketing from "./pages/Marketing";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const id = hash.slice(1);
      const t = setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 450);
      return () => clearTimeout(t);
    }
    window.scrollTo(0, 0);
    return undefined;
  }, [pathname, hash]);
  return null;
};

const GlobalAITextHighlight = () => {
  const { pathname } = useLocation();
  useAITextHighlight(pathname);
  return null;
};

const AnimatedRoutes = () => {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait" initial={false}>
      <motion.div
        key={location.pathname}
        className="page-3d"
        variants={pageVariants}
        initial="initial"
        animate="animate"
        exit="exit"
      >
        <Routes location={location}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/people" element={<People />} />
          <Route path="/tech-stack" element={<TechStack />} />
          <Route path="/investors" element={<Investors />} />
          <Route path="/marketing" element={<Marketing />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/:slug" element={<Legal />} />
        </Routes>
      </motion.div>
    </AnimatePresence>
  );
};

function App() {
  return (
    <div className="App" style={{ background: 'var(--tone-ink)', minHeight: '100vh' }}>
      <BrowserRouter>
        <ScrollToTop />
        <GlobalAITextHighlight />
        <Header />
        <AnimatedRoutes />
        <Footer />
        <Toaster position="bottom-right" theme="dark" />
      </BrowserRouter>
    </div>
  );
}

export default App;
